import { handleActions, createAction } from "redux-actions";
import { api } from "../../../services";

const CHAT_REPORT_GET = "REPORT_GET";
const CHAT_REPORT_UPDATE = "REPORT_UPDATE";

export const getChatReports = createAction(
  CHAT_REPORT_GET,
  async (filters, page, itemPerPage) => {
    try {
      const result = await api.ChatReport.list({ ...filters, page, itemPerPage });
      return {
        page,
        itemPerPage,
        reports: result.data,
        total: result.count
      };
    } catch (e) {
      return { reports: [] };
    }
  }
);

export const updateChatReport = createAction(
  CHAT_REPORT_UPDATE,
  async (id, data, reports, callback) => {
    try {
      await api.ChatReport.update(id, data);

      const updatedReports = reports.map(report => {
        if (report.id === id) {
          return {
            ...report,
            ...data
          };
        }

        return report;
      });

      callback && callback();

      return { reports: updatedReports };
    } catch (e) {
      callback && callback();

      return null;
    }
  }
);

const defaultState = {
  page: 1,
  itemPerPage: 10,
  total: 0,
  reports: [],
  filters: {}
};

const updateState = (state, { payload }) => ({
  ...state,
  ...payload
});

export default handleActions(
  {
    [CHAT_REPORT_GET]: updateState,
    [CHAT_REPORT_UPDATE]: updateState,
  },
  defaultState
);



// WEBPACK FOOTER //
// ./src/routes/Admin/ManageChatReportPage/chatReport.ducks.ts